"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.08 9.86h-.7v4h.56c1.26 0 1.89-.68 1.89-2s-.58-2-1.75-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.5 0h-23a.5.5 0 0 0 -.5.5v23a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5v-23a.5.5 0 0 0 -.5-.5zm-15.18 14.15a3.51 3.51 0 0 1 -2.5.81h-1.75v-6.17h1.93a3.28 3.28 0 0 1 2.35.8 3 3 0 0 1 .83 2.23 3 3 0 0 1 -.86 2.33zm4.77-.2a4.75 4.75 0 0 0 1.57-.32v1.1a4.35 4.35 0 0 1 -1.66.27 2.59 2.59 0 0 1 -2.06-.81 3.46 3.46 0 0 1 -.72-2.35 3.85 3.85 0 0 1 .35-1.68 2.54 2.54 0 0 1 1-1.11 3 3 0 0 1 1.54-.39 4.11 4.11 0 0 1 1.8.44l-.42 1.06a6.76 6.76 0 0 0 -.69-.29 2.18 2.18 0 0 0 -.69-.12 1.35 1.35 0 0 0 -1.15.56 2.61 2.61 0 0 0 -.4 1.54c-.02 1.42.5 2.15 1.53 2.15zm5.5 0a4.8 4.8 0 0 0 1.58-.32v1.1a4.4 4.4 0 0 1 -1.7.31 2.6 2.6 0 0 1 -2.06-.81 3.51 3.51 0 0 1 -.71-2.35 3.85 3.85 0 0 1 .35-1.68 2.48 2.48 0 0 1 1-1.11 2.93 2.93 0 0 1 1.53-.39 4.15 4.15 0 0 1 1.81.44l-.39 1.06a6.07 6.07 0 0 0 -.7-.29 2.09 2.09 0 0 0 -.69-.12 1.33 1.33 0 0 0 -1.14.56 2.54 2.54 0 0 0 -.4 1.54c-.02 1.38.49 2.11 1.52 2.11z"
  }));
};

exports["default"] = _default;